/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import ThankYou from "./ThankYou";
import CountryDropdown from "./CountryDropdown";

export {
    ThankYou,
    CountryDropdown
};
